import { useLocales } from '@shared/locales'
import { Button, Flex } from 'antd'
import { Add } from 'iconsax-react'
import { useState } from 'react'

import { AddEditDocument } from './AddEditDocument'

type ModalType = 'add'

export const DocumentsHeader = () => {
  const { t } = useLocales()
  const [modalType, setModalType] = useState<ModalType | null>(null)

  return (
    <Flex justify="flex-end">
      <Button
        onClick={() => setModalType('add')}
        icon={<Add size={16} />}
        type="primary"
      >
        {t('documents.add_document')}
      </Button>

      {modalType === 'add' && (
        <AddEditDocument open onCancel={() => setModalType(null)} />
      )}
    </Flex>
  )
}
